export default {
  ResreportsAnalytics: "التقارير والتحليلات",
  RestotalPurchase: "إجمالي المشتريات",
  RestotalOrders: "إجمالي الطلبات",
  ResitemsReceived: "العناصر المستلمة",
  RespendingGRN: "إشعارات GRN المعلقة",
  RestopSuppliers: "أفضل الموردين",
  Ressupplier: "المورد",
  Resorders: "الطلبات",
  Resamount: "المبلغ",
  ResnoData: "لا توجد بيانات",
  Resreports: "التقارير",
  ResselectReportModule: "اختر نوع التقرير",
  RespurchaseReport: "تقرير المشتريات",
  RespurchaseReportDesc: "الطلبات المرسلة إلى الموردين",
  ResgrnReport: "تقرير الاستلام GRN",
  ResgrnReportDesc: "تفاصيل البضائع المستلمة",
  ResinvoiceReport: "تقرير الفواتير",
  ResinvoiceReportDesc: "فواتير الموردين",
  RessupplierPerformance: "أداء الموردين",
  RessupplierPerformanceDesc: "تحليلات الموردين",
  ResbackToReports: "العودة إلى التقارير",

  //GRNReport

    resloading_grn_report: "جاري تحميل تقرير GRN...",
  resgrn_report: "تقرير GRN",
  restotal_grns: "إجمالي GRN",
  restotal_received: "إجمالي المستلم",
  ressearch_grn_order: "ابحث برقم GRN / الطلب...",
  resall_status: "كل الحالات",
  resgrn_id: "رقم GRN",
  resreceived_qty: "الكمية المستلمة",
  resno_data_found: "لا توجد بيانات",
  resprev: "السابق",
  resnext: "التالي",
  respage: "الصفحة",
  resof: "من",
  status_confirmed: "مؤكد",
status_draft: "مسودة",

  // Supplier Report
  resloading_supplier_report: "جاري تحميل تقرير الموردين...",
  ressupplier_performance: "أداء الموردين",
  restotal_suppliers: "إجمالي الموردين",
  resdelivered_orders: "الطلبات المسلمة",
  ressuccess_rate: "نسبة النجاح",
  ressupplier: "المورد",
  resorders: "الطلبات",
  resdelivered: "تم التسليم",
  respending: "قيد الانتظار",
  restotal_spend: "إجمالي الإنفاق",
  ressuccess_percent: "نسبة النجاح %",
  resgrn_dashboard_subtitle: "لوحة متابعة إشعارات استلام البضائع",

restotal_grns: "إجمالي إشعارات الاستلام",
restotal_received: "إجمالي المستلم",

resdraft: "مسودة",

ressearch_grn: "ابحث برقم GRN أو الطلب أو المورد",

reslatest: "الأحدث",
resoldest: "الأقدم",
reshighest_qty: "أعلى كمية",

resgrn_details: "تفاصيل إشعار الاستلام",


// Invoice Report
resloading_invoice_report: "جاري تحميل تقرير الفواتير...",
resinvoice_report: "تقرير الفواتير",
resinvoice_dashboard_subtitle: "تحليلات الفواتير والبيانات المالية",

resdownloading: "جاري التحميل...",

restotal_invoices: "إجمالي الفواتير",
restotal_amount: "إجمالي المبلغ",
restax_amount: "مبلغ الضريبة",

ressearch_invoice: "ابحث بالفاتورة أو المورد",

resunpaid: "غير مدفوعة",

reshighest_amount: "أعلى مبلغ",
resclear: "إعادة تعيين",

resinvoice: "الفاتورة",

resinvoice_details: "تفاصيل الفاتورة",
resinvoice_no: "رقم الفاتورة",
ressearch_supplier: "ابحث عن المورد",
resdownload_excel: "تحميل إكسل",
resdownload_pdf: "تحميل PDF",
};
